/**
 * Copyright (c) 2018
 * @summary Text Template
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React from 'react';
import { isFunction } from 'lodash/lang';

import TextLengthCounter from './TextLengthCounter';

class TextTemplate extends React.Component {
  onChangeHandler = event => {
    this.props.onChangeTextHandler &&
      this.props.onChangeTextHandler(
        event,
        this.props.formLabelId,
        this.props.templateData.itemId,
        this.props.templateData
      );
  };

  render({ props } = this) {
    const disabled = isFunction(props.isAbleToEdit) && !props.isAbleToEdit();
    return (
      <div
        className={
          props.customClassObject && props.customClassObject.containerClass
            ? props.customClassObject.containerClass
            : ''
        }
      >
        <input
          className={
            props.customClassObject && props.customClassObject.elementClass ? props.customClassObject.elementClass : ''
          }
          type="text"
          uid={`${this.props.formId}##${this.props.templateData.oid}`}
          onChange={event => this.onChangeHandler(event)}
          value={this.props.templateData.inputValue || ''}
          maxLength="3000"
          disabled={disabled}
        />
        {props.isItemGroup && <TextLengthCounter characters={props.templateData.inputValue || ''} />}
      </div>
    );
  }
}

export default TextTemplate;
